import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'admin-ladder-management',
  templateUrl: './ladder-management.component.html',
  styleUrls: ['./ladder-management.component.scss']
})
export class AdminLadderManagementComponent implements OnInit {
  public ladders: any[] = [];
  public editingLadder: any = null;
  public showForm: boolean = false;
  public isEditMode: boolean = false;
  public busy: boolean = false;
  public message: string = '';

  public ladderForm: FormGroup;

  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.ladderForm = this.fb.group({
      id: [0],
      ladderId: ['', [Validators.required, Validators.pattern('^[A-Z0-9-]+$')]],
      name: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      forfeitPoints: [4, Validators.required],
      type: ['Normal', Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadLadders();
  }

  loadLadders(): void {
    this.busy = true;
    this.http.get<any>('/admin/ladders/getall').subscribe(
      (resp) => {
        if (resp) {
          this.ladders = resp;
        }
        this.busy = false;
      },
      (err) => {
        this.message = 'Error loading ladders: ' + err.error;
        this.busy = false;
      }
    );
  }

  showAddForm(): void {
    this.isEditMode = false;
    this.showForm = true;
    this.message = '';
    this.ladderForm.reset({
      id: 0,
      ladderId: '',
      name: '',
      startDate: '',
      endDate: '',
      forfeitPoints: 4,
      type: 'Normal'
    });
  }

  editLadder(ladder: any): void {
    this.isEditMode = true;
    this.showForm = true;
    this.message = '';
    
    // Convert dates to proper format for input[type="datetime-local"]
    const startDate = new Date(ladder.startDate);
    const endDate = new Date(ladder.endDate);
    
    this.ladderForm.patchValue({
      id: ladder.id,
      ladderId: ladder.ladderId,
      name: ladder.name,
      startDate: this.formatDateForInput(startDate),
      endDate: this.formatDateForInput(endDate),
      forfeitPoints: ladder.forfeitPoints,
      type: ladder.type
    });
  }

  formatDateForInput(date: Date): string {
    // Format: YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  cancelEdit(): void {
    this.showForm = false;
    this.editingLadder = null;
    this.message = '';
  }

  saveLadder(): void {
    if (this.ladderForm.invalid) {
      this.message = 'Please fill in all required fields';
      return;
    }

    this.busy = true;
    const ladder = this.ladderForm.value;

    if (this.isEditMode) {
      // Update existing ladder
      this.http.put(`/admin/ladders/update/${ladder.id}`, ladder).subscribe(
        (resp) => {
          this.message = 'Ladder updated successfully';
          this.busy = false;
          this.showForm = false;
          this.loadLadders();
        },
        (err) => {
          this.message = 'Error updating ladder: ' + err.error;
          this.busy = false;
        }
      );
    } else {
      // Create new ladder
      this.http.post('/admin/ladders/create', ladder).subscribe(
        (resp) => {
          this.message = 'Ladder created successfully';
          this.busy = false;
          this.showForm = false;
          this.loadLadders();
        },
        (err) => {
          this.message = 'Error creating ladder: ' + err.error;
          this.busy = false;
        }
      );
    }
  }

  deleteLadder(ladder: any): void {
    if (!confirm(`Are you sure you want to delete ladder "${ladder.name}"? This action cannot be undone.`)) {
      return;
    }

    this.busy = true;
    this.http.delete(`/admin/ladders/delete/${ladder.id}`).subscribe(
      (resp) => {
        this.message = 'Ladder deleted successfully';
        this.busy = false;
        this.loadLadders();
      },
      (err) => {
        this.message = 'Error deleting ladder: ' + err.error;
        this.busy = false;
      }
    );
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }
}

